import { render, staticRenderFns } from "./Badge9.vue?vue&type=template&id=164e5bf0&scoped=true"
import script from "./Badge9.vue?vue&type=script&lang=js"
export * from "./Badge9.vue?vue&type=script&lang=js"
import style0 from "./Badge9.vue?vue&type=style&index=0&id=164e5bf0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "164e5bf0",
  null
  
)

export default component.exports